import React from 'react';

interface CancelPageProps {
  onRetry?: () => void;
  onBack?: () => void;
  onUpgrade?: () => void;
}

export const CancelPage: React.FC<CancelPageProps> = ({ onRetry, onBack, onUpgrade }) => {
  return (
    <div className="cancel-page" style={{
      maxWidth: '600px',
      margin: '0 auto',
      padding: '40px 20px',
      textAlign: 'center',
      fontFamily: 'system-ui, -apple-system, sans-serif'
    }}>
      {/* Cancel Icon */}
      <div style={{
        width: '80px',
        height: '80px',
        background: '#f59e0b',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 auto 32px',
        fontSize: '40px',
        color: 'white',
        fontWeight: 'bold'
      }}>
        ⚠
      </div>

      {/* Cancel Message */}
      <h1 style={{
        fontSize: '32px',
        fontWeight: '700',
        color: '#1f2937',
        marginBottom: '16px'
      }}>
        Subscription Cancelled
      </h1>

      <p style={{
        fontSize: '18px',
        color: '#6b7280',
        marginBottom: '32px',
        lineHeight: '1.6'
      }}>
        Your subscription purchase was cancelled. No charges were made to your account. You can try again or continue with the free plan.
      </p>

      {/* Information Box */}
      <div style={{
        background: '#fffbeb',
        border: '1px solid #fed7aa',
        borderRadius: '12px',
        padding: '24px',
        marginBottom: '32px'
      }}>
        <h3 style={{
          fontSize: '18px',
          fontWeight: '600',
          color: '#92400e',
          marginBottom: '12px'
        }}>
          What happened?
        </h3>
        <p style={{
          fontSize: '16px',
          color: '#92400e',
          margin: '0',
          lineHeight: '1.5'
        }}>
          You either cancelled the subscription process or encountered an issue. Your account has not been charged and you can continue using the free plan or try subscribing again.
        </p>
      </div>

      {/* Action Buttons */}
      <div style={{
        display: 'flex',
        gap: '16px',
        justifyContent: 'center',
        flexWrap: 'wrap'
      }}>
        {(onRetry || onUpgrade) && (
          <button
            onClick={onRetry || onUpgrade}
            style={{
              background: '#3b82f6',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              padding: '16px 32px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.2s ease'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.background = '#2563eb';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.background = '#3b82f6';
            }}
          >
            {onRetry ? 'Try Again' : 'View Plans'}
          </button>
        )}

        {onBack && (
          <button
            onClick={onBack}
            style={{
              background: 'none',
              color: '#6b7280',
              border: '1px solid #d1d5db',
              borderRadius: '8px',
              padding: '16px 32px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.2s ease'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.background = '#f9fafb';
              e.currentTarget.style.borderColor = '#9ca3af';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.background = 'none';
              e.currentTarget.style.borderColor = '#d1d5db';
            }}
          >
            Back to App
          </button>
        )}
      </div>

      {/* Help Text */}
      <div style={{
        marginTop: '32px',
        padding: '16px',
        background: '#f9fafb',
        borderRadius: '8px'
      }}>
        <p style={{
          fontSize: '14px',
          color: '#6b7280',
          margin: '0',
          lineHeight: '1.5'
        }}>
          Need help? Contact our support team if you're experiencing issues with the payment process.
        </p>
      </div>
    </div>
  );
}; 